/**
  * 用户 接口的统一出口
  */
 import axios from '../http' // 导入http中创建的axios实例
 import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来
 
 const index = {
    // 我在园区的角色
    parkRole (params) {
        return axios.get('/home/park/role', { params: params })
    },
	// 我在园区的积分记录
	parkScore (params) {
		return axios.get('/home/park/score', { params: params })
	},
	// 园区等级规则
	levelrule (params) {
		return axios.get('/home/park/levelrule', { params: params })
	},
	/*  园区管理模块 将后台功能同步到前台 */
	// 园区详情
	parkInfo (params) {
		return axios.get('/home/park/info', { params: params })
	},
	// 园区匠人列表
	tradelist (params) {
		return axios.get('/home/park/tradelist', { params: params })
	},
	// 待审核的匠人
	pendTradelist (params){
		return axios.get('/home/park/pend/tradelist', { params: params })
	},
	// 审核匠人
    tradereview (params){
		return axios.post('/home/park/trade/review', qs.stringify(params))
	},
	// 二级分销商
	secondAgentlist (params){
		return axios.get('/home/park/agentlist', { params: params })
	},
	// 一级分销商
	firstagentlist (params){
		return axios.get('/home/park/firstagentlist', { params: params })
	},
	// 订单列表
	orderlist (params){
		return axios.get('/home/park/orderlist', { params: params })
	},
	// 收入记录
	moneylog (params){
		return axios.get('/home/park/moneylog', { params: params })
	},
	// 银行卡列表
	banklist(params){
		return axios.get('/home/park/banklist', { params: params })
	},
	// 提现
	applytx (params){
		return axios.post('/home/park/applytx', qs.stringify(params))
	},
	// 融宝解密
	getparktxjm(params){
		return axios.get('/home/park/moneylog/jm', { params: params })
	}
 }
 
 // 导出接口
 export default index